import cn from 'classnames';
import { Grid, Icon, Button } from 'ht-styleguide';
import styles from './emptystate.module.scss';

/* Types */
type EmptyStateProps = {
  className?: string;
  additionalTitle?: string;
  iconName?: string;
  iconStyles?: string;
  title?: string;
  text?: string;
  onClick?: (...args: any[]) => any;
  buttonText?: string;
  buttonTheme?: string;
  buttonClasses?: string;
  showButton?: boolean;
};
const EmptyState = ({
  additionalTitle,
  iconName = 'logo-house-black',
  iconStyles,
  title,
  text,
  className,
  onClick,
  showButton = false,
  buttonText,
  buttonTheme,
  buttonClasses,
}: EmptyStateProps) => {
  const subTitle = additionalTitle && <span>&ldquo;{additionalTitle}&rdquo;</span>;
  return (
    <Grid.Fluid classes={cn(className, styles.container)}>
      <Grid.Row classes={styles.customRow}>
        <Grid.Column classes={cn(iconStyles, styles.iconContainer)} sm={4} md={8} lg={12}>
          <Icon name={iconName!} className={styles.icon} />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row classes={styles.customRow}>
        <Grid.Column sm={4} md={8} lg={12}>
          <h4 className={cn('paddingTop-small1', styles.header)}>
            {title} {subTitle}
          </h4>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row classes={styles.customRow}>
        <Grid.Column sm={4} md={6} mdOffset={1} lg={12} classes={styles.offsetOverride}>
          <p className="p1 n700 paddingTop-tiny1">{text}</p>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        {showButton && (
          <Grid.Column sm={4} md={2} mdOffset={3} lg={2} lgOffset={5} classes={cn(styles.button, 'paddingTop-small')}>
            <Button onClick={onClick} theme={buttonTheme} className={buttonClasses} small>
              {buttonText}
            </Button>
          </Grid.Column>
        )}
      </Grid.Row>
    </Grid.Fluid>
  );
};

export default EmptyState;
